import React from 'react';
import { Button } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { ReduxState } from 'src/redux';
import { openSurvey, closeSurvey } from 'src/redux/reducers/Survey';

const FeedbackButton: React.FC = () => {
  const dispatch = useDispatch()

  const { open, survey } = useSelector((state: ReduxState) => state.Survey);

  const handleOpenSurvey = () => {
    if (open && survey === "feedback") {
      dispatch(closeSurvey())
    } else {
      dispatch(openSurvey("feedback"))
    }
  }

  return (
    <Button
      variant="primary"
      style={{
        position: 'fixed',
        right: '5rem',
        bottom: '28px',
        zIndex: 1050
        // transform: 'rotate(-90deg)'
      }}
      onClick={handleOpenSurvey}
    >
      Feedback
    </Button>
  );
};

export default FeedbackButton;
